<template>
  <div id="app">
    <router-view/>
    <about-component v-if="aboutOpen"/>
  </div>
</template>

<script>

import AboutComponent from 'comp/About'

/**
 * App component
 */
export default {
  components: {
    AboutComponent
  },
  data () {
    return {
      aboutOpen: this.$store.getters.aboutOpen
    }
  },
  computed: {
    isLoggedIn: function () { return this.$store.getters.isLoggedIn },
    user: function () { return this.$store.getters.user }
  },
  methods: {
    logout: function () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    }
  },
  created () {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch(logout)
        }
        throw err
      })
    })
  },
  mounted () {
    // about change
    this.$store.watch(
      () => this.$store.getters['aboutOpen'],
      about => {
        this.aboutOpen = about
      }
    )
  }
}

</script>

<style lang="stylus" scoped>

#app
  height: 100%
  > span
    position: absolute
    bottom: 0

</style>
